/**
 * External URLs that live outside the app (marketing site, docs). Centralized
 * so a single edit re-points every in-app link.
 */

/**
 * Public waitlist form for parents who don't use Gmail (Notion form approved
 * by George, YAR-433). Used by the
 * signed-out Hero ("Don't use Gmail? Join the waitlist") and the
 * unsupported-account notice.
 *
 * NOT the internal `/waitlist` route: that is a POST-auth holding page
 * ("You're on the list!") which redirects signed-out visitors straight back
 * to `/`, so pointing a signed-out CTA at it looks like a dead link (YAR-277).
 */
export const WAITLIST_URL =
  'https://speckled-toast-c3c.notion.site/3e2a1a0f90598098a19bd9b6933c2f37';
